/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_CopyInputs */

const en_admin_ai_chat_copy = /** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const de_admin_ai_chat_copy = /** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const es_admin_ai_chat_copy = /** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const fr_admin_ai_chat_copy = /** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const nl_admin_ai_chat_copy = /** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren`)
};

/** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */
const it_admin_ai_chat_copy = en_admin_ai_chat_copy;

/** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_copy = en_admin_ai_chat_copy;

/** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */
const pl_admin_ai_chat_copy = en_admin_ai_chat_copy;

/** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */
const hu_admin_ai_chat_copy = en_admin_ai_chat_copy;

/** @type {(inputs: Admin_Ai_Chat_CopyInputs) => LocalizedString} */
const ro_admin_ai_chat_copy = en_admin_ai_chat_copy;

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Admin_Ai_Chat_CopyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_copy = /** @type {((inputs?: Admin_Ai_Chat_CopyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_CopyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_copy(inputs)
	if (locale === "de") return de_admin_ai_chat_copy(inputs)
	if (locale === "es") return es_admin_ai_chat_copy(inputs)
	if (locale === "fr") return fr_admin_ai_chat_copy(inputs)
	if (locale === "nl") return nl_admin_ai_chat_copy(inputs)
	if (locale === "it") return it_admin_ai_chat_copy(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_copy(inputs)
	if (locale === "pl") return pl_admin_ai_chat_copy(inputs)
	if (locale === "hu") return hu_admin_ai_chat_copy(inputs)
	return ro_admin_ai_chat_copy(inputs)
});
export { admin_ai_chat_copy as "admin.ai_chat.copy" }